import { createSlice } from '@reduxjs/toolkit';
import { IPromotionsState } from '../types';
import { getPromotions } from '../../service/api';

const initialState: IPromotionsState = {
  page: null,
  pending: false,
  error: null,
};

export const promotionsSlice = createSlice({
  name: 'promotionsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPromotions.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getPromotions.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getPromotions.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default promotionsSlice.reducer;
